import { EditOutlined } from "@mui/icons-material";
import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, CardBox } from "../../../../../components";
import { errorAlert } from "../../../../../helpers/alerts";
import { validatePermission } from "../../../../../helpers/authentication";
import { setCurrentPaymentServiceProduct, setCurrentPaymentServiceSegment, setPaymentServiceProducts, setPaymentServiceSegments } from "redux/slices/admin/providerSlice";
import { getCredPaymentServiceProductsService, getCredPaymentServiceSegmentsService } from "services/admin/providerService";
import { Box, Grid } from "@mui/material";

const CredPDSScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    providerCredSelected,
    paymentServiceProducts,
    currentPaymentServiceProduct
  } = useSelector((store) => store.providers);


  useEffect(() => {
    getCredPaymentServiceProductsService(providerCredSelected.id)
      .then(list => {
        dispatch(setPaymentServiceProducts(list));
      }).catch(error => errorAlert(error))
  }, [providerCredSelected]);

  const handlerClickProduct = (product) => {
    if (product.id !== currentPaymentServiceProduct?.id) {
      dispatch(setCurrentPaymentServiceProduct(product));
    }
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my={2}
      >
        <div>
          <BackButton click={() => navigate('../..')} />
        </div>
        <div className="container-title">
          <div className="commerce">Instancia</div>
          <div className="subtitle">{providerCredSelected.name_connector}</div>
        </div>
        <div>
        </div>
      </Grid>
      <CardBox
        name={"Productos"}
        values={paymentServiceProducts?.filter(({ state }) => state)}
        handleSelect={handlerClickProduct}
        buttons={[
          validatePermission('proveedores', 'productos', ['agregar', 'editar', 'eliminar']) &&
          {
            icon: <EditOutlined />,
            key: "products",
            name: "Administrar",
            click: () => navigate("productos"),
          },
        ]}
        formatter={({ idProduct: item }) => ({
          ...item,
          image: `/v3/file/${item?.fd}/`,
        })}

      />
    </>
  );
};

export default CredPDSScreen;
